export default __webpack_public_path__ + "assets/favicon.fffcd859809d7243a9146ccb618462f9.png";